import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { INSIGHTS_QUERY_KEY } from '@insights_module/constants/queryKeys';
import { generateContent } from '@services/index';
import { isBalanced } from '@utils/commonUtils';

// valid query string must start with '{' and end with '}' and have at least one of AQL query types
const queryStringRegex =
  /^\{.*(?:title|duration|original_url|published_date|created_at|updated_at|groups|transcript|brand_safety_garm|brand_safety_iab|named_entities|topics|keywords|contextual|id|name|type|external_ids|audio_count|podcast_metadata|author|apple_star_rating|apple_rating_count|apple_categories|podcast_type|all|any).*\}$/;

export const useGenerateAQLFilter = () => {
  const [message, setMessage] = useState<string>('');
  const [result, setResult] = useState<object | null | 'error'>(null);

  const { data: filterData, isLoading: isLoadingFilterData } = useQuery({
    queryKey: [INSIGHTS_QUERY_KEY.generate_aql_filter],
    queryFn: () =>
      generateContent({
        type: 'aql_builder',
        prompt: message,
      }),
    enabled: !!message,
    staleTime: 0,
    cacheTime: 0,
    onSettled: () => {
      setMessage('');
    },
  });

  const sendMessage = (message: string) => {
    setMessage(message);
  };

  useEffect(() => {
    if (!filterData?.data?.response?.content) {
      return;
    }
    let content = filterData?.data?.response?.content || '';
    // change single quotes to double quotes
    content = content.replace(/'/g, '"');
    if (!queryStringRegex.test(content) || !isBalanced(content)) {
      setResult('error');
      return;
    }

    try {
      const params = JSON.parse(content || '{}');
      if (!params?.all && !params?.any) {
        setResult({ all: [params] });
        return;
      }

      setResult(params);
    } catch (e) {
      setResult('error');
    }
  }, [filterData]);

  return {
    sendMessage,
    result,
    isLoading: isLoadingFilterData && !!message,
  };
};
